// extracted by mini-css-extract-plugin
export var container = "_ur-0";
export var table = "_ur-2";
export var tableWrapper = "_ur-1";